var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9987 3.33301C7.42203 3.33301 5.33203 5.42301 5.33203 7.99967C5.33203 10.577 7.42203 12.6663 9.9987 12.6663C12.576 12.6663 14.6654 10.577 14.6654 7.99967C14.6654 5.42301 12.576 3.33301 9.9987 3.33301M9.9987 4.66634C11.8374 4.66634 13.332 6.16167 13.332 7.99967C13.332 9.83834 11.8374 11.333 9.9987 11.333C8.1607 11.333 6.66536 9.83834 6.66536 7.99967C6.66536 6.16167 8.1607 4.66634 9.9987 4.66634",
    fill: "#121312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53627 3.57218C2.63951 4.1965 1.33337 5.97027 1.33337 7.99742C1.33337 10.0246 2.63951 11.7983 4.53627 12.4227C4.88601 12.5378 5.26284 12.3476 5.37795 11.9979C5.49307 11.6481 5.30287 11.2713 4.95314 11.1562C3.59908 10.7105 2.66671 9.44429 2.66671 7.99742C2.66671 6.55055 3.59908 5.28436 4.95314 4.83867C5.30287 4.72355 5.49307 4.34672 5.37795 3.99699C5.26284 3.64726 4.88601 3.45706 4.53627 3.57218Z",
    fill: "#121312"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.e6f4abcc8aa3d716a0d0bd49bd8bcd6a.svg";
export { ForwardRef as ReactComponent };